var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9361 -0.0543213H8.95449C1.67008 -0.0543213 -0.0546875 1.67045 -0.0546875 8.95485V16.9365C-0.0546875 24.2209 1.67008 25.9457 8.95449 25.9457H16.9361C24.2205 25.9457 25.9453 24.2209 25.9453 16.9365V8.95485C25.9453 1.67045 24.2205 -0.0543213 16.9361 -0.0543213ZM20.6608 8.20284C21.2296 8.20284 21.358 8.49642 21.2296 8.90008C21.0291 9.82522 19.3645 12.2793 18.849 13.0394C18.751 13.1838 18.6945 13.2671 18.6975 13.2671C18.4956 13.5973 18.4222 13.7441 18.6975 14.1111C18.797 14.2468 19.0079 14.4538 19.249 14.6904C19.497 14.9338 19.7769 15.2084 20.0002 15.4689C20.8075 16.3863 21.4314 17.157 21.5965 17.6891C21.7433 18.2212 21.4864 18.4964 20.936 18.4964H19.0461C18.5452 18.4964 18.2871 18.2088 17.7369 17.5958C17.5009 17.333 17.2113 17.0103 16.8259 16.6249C15.7066 15.5423 15.2112 15.3955 14.936 15.3955C14.5507 15.3955 14.4406 15.4872 14.4406 16.0377V17.7441C14.4406 18.2028 14.2938 18.4781 13.0828 18.4781C11.0828 18.4781 8.86259 17.2671 7.30296 15.0102C4.95434 11.7074 4.31213 9.21201 4.31213 8.7166C4.31213 8.44137 4.40388 8.18449 4.95434 8.18449H6.86259C7.33966 8.18449 7.52314 8.38632 7.70663 8.91843C8.64241 11.6157 10.202 13.9827 10.8442 13.9827C11.0828 13.9827 11.1929 13.8726 11.1929 13.2671V10.4781C11.1476 9.68533 10.8716 9.33993 10.667 9.08381C10.5401 8.92496 10.4406 8.80045 10.4406 8.62486C10.4406 8.40467 10.6241 8.18449 10.9176 8.18449H13.8901C14.2938 8.18449 14.4406 8.40467 14.4406 8.88174V12.6432C14.4406 13.0469 14.6057 13.1937 14.7342 13.1937C14.9727 13.1937 15.1745 13.0469 15.6149 12.6065C16.9727 11.0836 17.9452 8.73495 17.9452 8.73495C18.0736 8.45972 18.2938 8.20284 18.7708 8.20284H20.6608Z",
    fill: "#A0A6C3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.d2d969920b116acf6686867f546e21e3.svg";
export { ForwardRef as ReactComponent };